import { BreakpointRange } from '@mews-distributor/common';
import { useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews/text-keys';
import { OpenableVerticalProgressIndicator, ProgressIndicator, withBreakpointRange } from '@optimus-web/core';
import { Navbar } from '../Navbar';

// TODO delete whole component after ProgressIndicator refactoring https://mews.myjetbrains.com/youtrack/issue/RND-42409
const BaseProgressIndicatorWrapper = ({ breakpointRange, steps, activeTab, onClick, ...other }: $TSFixMe) => {
    const localizeText = useLocalizeText();
    if (activeTab == null) {
        return null;
    }

    const progressIndicatorProps = {
        steps,
        activeStep: activeTab.name,
        onStepChange: onClick,
    };

    return (
        <Navbar {...other} aria-label={localizeText({ textKey: TextKey.Progress })}>
            {breakpointRange === BreakpointRange.Desktop ? (
                <ProgressIndicator {...progressIndicatorProps} />
            ) : (
                <OpenableVerticalProgressIndicator {...progressIndicatorProps} />
            )}
        </Navbar>
    );
};

export const ProgressIndicatorWrapper = withBreakpointRange(BaseProgressIndicatorWrapper);
